/**
 * @file route-plan-info.service.ts
 * @module app/modules/orders-delivery/services/route-plan-info.service
 * @description Shared fetch helper for `routePlanning.planInfo`. Consolidates the
 * duplicated APICallService construction for route-plan info lookups across
 * all-orders, goods-loading-details, past-delivery-route-details, review-orders-list,
 * and route-details.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.1
 * @version 2.1.2
 */

import { PermissionModule } from 'src/utils/constants';
import APICallService from '../../../../api/apiCallService';
import { routePlanning } from '../../../../api/apiEndPoints';
import { RoutePlanInfo } from '../types';

/**
 * Fetches route-plan info (record, vehicles, orders summary) for a given route id.
 */
export const fetchRoutePlanInfo = async (
  routeId: string,
  moduleName: PermissionModule,
  warehouseId?: string | null
): Promise<RoutePlanInfo> => {
  let apiService = new APICallService(
    routePlanning.planInfo,
    routeId,
    '',
    '',
    '',
    '',
    moduleName,
    warehouseId
  );
  return apiService.callAPI();
};
